"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentViewImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing DocumentView operations. */
var DocumentViewImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class DocumentView class.
   * @param client Reference to the service client
   */
  function DocumentViewImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentViewImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param documentViewName
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentViewImpl, [{
    key: "getDocumentView",
    value: function getDocumentView(portalId, documentViewName, options) {
      var operationArguments = {
        portalId: portalId,
        documentViewName: documentViewName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentViewOperationSpec);
    }
  }]);
  return DocumentViewImpl;
}(); // Operation Specifications


exports.DocumentViewImpl = DocumentViewImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getDocumentViewOperationSpec = {
  path: "/api/Portals({portalId})/DocumentViews/{documentViewName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentViewInfo
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentViewName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};